// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import api from './advisorApi';
import type { EmailPreviewRequest, EmailPreviewResponse } from '../types/emailPreview';

/**
 * Unified email-preview client.
 *
 * <p>Single entrypoint for every advisor compose dialog — LOA invitation,
 * add-policies invitation, resend invitation, CoA invitation, and provider
 * nudge. Replaces the per-kind {@code getInvitationPreview},
 * {@code getAddPoliciesInvitationPreview}, {@code getResendInvitationData},
 * and {@code getNudgeData} methods previously spread across
 * {@code invitationApi} and {@code nudgeApi}.
 */
export const emailPreviewApi = {
  preview: async (request: EmailPreviewRequest): Promise<EmailPreviewResponse> => {
    const response = await api.post<EmailPreviewResponse>('/email-preview', request);
    return response.data;
  },
};

export default emailPreviewApi;
